import React, { FC, MouseEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Modal } from 'antd';

// Shared UI Library Components
import {
  CustomButton,
  CustomIcon,
  EIconName,
} from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './delete-specialty-specialisations-modal.scss';

// Store entities
import { deleteCompanySpecialtySpecialisations } from '../../store/company/company.thunks';

// Models
import { ISpecialtySpecialisations } from '../../interfaces/company.interfaces';

type TDeleteSpecialtySpecialisationsModalProps = {
  open: boolean;
  info: ISpecialtySpecialisations | null;
  onSubmit?: () => void;
  onCancel?: () => void;
}

export const DeleteSpecialtySpecialisationsModal: FC<TDeleteSpecialtySpecialisationsModalProps> = (
  {
    open = false,
    info = null,
    onSubmit = () => {},
    onCancel = () => {}
  }: TDeleteSpecialtySpecialisationsModalProps
) => {

  const [deletingItem, setDeletingItem] = useState<boolean>(false);

  const dispatch = useDispatch<any>();

  const handleCancel = (_: MouseEvent<HTMLButtonElement>): void => {
    onCancel();
  };

  const handleSubmit = async (): Promise<void> => {
    if (!info) return;
    setDeletingItem(true);

    const { payload } = await dispatch(deleteCompanySpecialtySpecialisations(info?.speciality.id));
    setDeletingItem(false);

    if (!payload) return;
    onSubmit();
  }

  return (
    <Modal
      rootClassName="delete-specialty-specialisations-modal"
      width={ '396px' }
      open={ open }
      centered={ true }
      closeIcon={ false }
      title={ 'Are you sure you want to delete Specialty & Specialisation(s)?' }
      footer={ [
        <CustomButton key="no" text={ 'No' } disabled={ deletingItem } type={ 'text' } onClick={ handleCancel }/>,
        <CustomButton key="yes" text={ 'Yes' } loading={ deletingItem } onClick={ handleSubmit }/>
      ] }
      onCancel={ handleCancel }
    >
      <div className="delete-specialty-specialisations-modal--body">
        <div className="body-item body-item--error-message">
          <div className="error-message--icon">
            <CustomIcon name={ EIconName.Warning }/>
          </div>
          <div className="error-message--text">
            Be aware that deleting the "{ info?.speciality.name }" Specialty &
            Specialisation(s) will result in their deletion from the Consultants' Profiles. Please proceed with caution.
          </div>
        </div>
      </div>
    </Modal>
  )
};
